import './App.scss'
import {BrowserRouter, Route, Routes} from "react-router-dom";
import AppRouter from "./pages/Router/AppRouter";
import React from "react";

function App() {

  return (
      <div className={"App"}>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<AppRouter/>}/>
          </Routes>
        </BrowserRouter>
      </div>
  )
}

export default App
